import { Button, TYPE as ButtonType } from 'components/Button'
import ListHeader from 'components/ListHeader'
import Section from 'components/Section'
import { SectionType, Size } from 'components/Section/Section'
import * as React from 'react'
import DisplayContent from '../../shared/content'

interface FoodLoversBookNowProps {
  onClick: () => void
}

export const FoodLoversBookNow: React.FC<FoodLoversBookNowProps> = ({
  onClick,
}) => {
  return (
    <Section type={SectionType.white} size={Size.m}>
      <ListHeader noMarginBottom>
        <Button cutOff="none" type={ButtonType.plain} onClick={onClick}>
          <DisplayContent contentKey="boek-direct" edit={true}>
            Boek direct
          </DisplayContent>
        </Button>
      </ListHeader>
    </Section>
  )
}
